import { InitialStateFactory } from '../factories/initialState.factory';
import { ReducerFactory } from '../factories/reducers.factory';

export const usersReducer = ReducerFactory('users', InitialStateFactory());
